import React, { useState } from "react";

import ModalEliminarOtrosParticipantes from "./ModalEliminarOtrosParticipantes";
import ModalModificarOtrosParticipantes from "./ModalModificarOtrosParticipantes";

const TablaOtrosParticipantes = ({item, passActualizarTablaProcedimiento}) => {
  const [modalOnModificarOtrosParticipantes, setmodalOnModificarOtrosParticipantes]=useState(false)
  const [modalOnEliminarOtrosPareticipantes, setmodalOnEliminarOtrosPareticipantes]=useState(false)
  const handleClickModificar=()=>{
    setmodalOnModificarOtrosParticipantes(true)
  }

  const hancleClickEliminar=()=>{
    setmodalOnEliminarOtrosPareticipantes(true)
  }

  const passEliminarOtrosParticipantes=(data)=>{
    passActualizarTablaProcedimiento(data)
  }

  return (
    <>
      <tbody>
      <tr className="divide-y divide-slate-700">
        <td></td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
        <button
              type="button"
              onClick={handleClickModificar}
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Modificar 
            </button>
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          <button
            type="button"
            onClick={hancleClickEliminar}
            className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Eliminar 
          </button>
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersCod}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersNom}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersTip}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersTipDes}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersEsp}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PersNomEP}</td>
        
      </tr>
      </tbody>
      {modalOnModificarOtrosParticipantes? <ModalModificarOtrosParticipantes setmodalOnModificarOtrosParticipantes={setmodalOnModificarOtrosParticipantes} item={item} passEliminarOtrosParticipantes={passEliminarOtrosParticipantes}/>:null}
      {modalOnEliminarOtrosPareticipantes? <ModalEliminarOtrosParticipantes setmodalOnEliminarOtrosPareticipantes={setmodalOnEliminarOtrosPareticipantes} item={item} passEliminarOtrosParticipantes={passEliminarOtrosParticipantes}/>:null}
      
    </>
  );
};

export default TablaOtrosParticipantes;
